/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Measure_Explainer_BaseInputs */

const en_measure_explainer_base = /** @type {((inputs: Measure_Explainer_BaseInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_BaseInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} base + `)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " base + " }])
			})
		}
	)
);

const zh_hans1_measure_explainer_base = /** @type {((inputs: Measure_Explainer_BaseInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_BaseInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`基础费 ${i?.amount} + `)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "基础费 " }, { type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " + " }])
			})
		}
	)
);

const pt_br2_measure_explainer_base = /** @type {((inputs: Measure_Explainer_BaseInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_BaseInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} fixo + `)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " fixo + " }])
			})
		}
	)
);

const es_measure_explainer_base = /** @type {((inputs: Measure_Explainer_BaseInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_BaseInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} fijo + `)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " fijo + " }])
			})
		}
	)
);

const fr_measure_explainer_base = /** @type {((inputs: Measure_Explainer_BaseInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_BaseInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} de base + `)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " de base + " }])
			})
		}
	)
);

const de_measure_explainer_base = /** @type {((inputs: Measure_Explainer_BaseInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_BaseInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} Basis + `)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " Basis + " }])
			})
		}
	)
);

const ru_measure_explainer_base = /** @type {((inputs: Measure_Explainer_BaseInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_BaseInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} базовая + `)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " базовая + " }])
			})
		}
	)
);

const it_measure_explainer_base = /** @type {((inputs: Measure_Explainer_BaseInputs) => LocalizedString) & { parts: (inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_BaseInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`${i?.amount} base + `)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_BaseInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "v", options: {}, attributes: {} }, { type: "text", value: String(i?.amount) }, { type: "markup-end", name: "v", options: {}, attributes: {} }, { type: "text", value: " base + " }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "{amount} base +" |
*
* @param {Measure_Explainer_BaseInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_explainer_base = /** @type {((inputs: Measure_Explainer_BaseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs: Measure_Explainer_BaseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Measure_Explainer_BaseInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { v: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Measure_Explainer_BaseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_measure_explainer_base(inputs)
			if (locale === "pt-BR") return pt_br2_measure_explainer_base(inputs)
			if (locale === "es") return es_measure_explainer_base(inputs)
			if (locale === "fr") return fr_measure_explainer_base(inputs)
			if (locale === "de") return de_measure_explainer_base(inputs)
			if (locale === "ru") return ru_measure_explainer_base(inputs)
			if (locale === "it") return it_measure_explainer_base(inputs)
			return en_measure_explainer_base(inputs)
		}),
		{
			parts: /** @type {(inputs: Measure_Explainer_BaseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_measure_explainer_base.parts === "function" ? zh_hans1_measure_explainer_base.parts(inputs) : [{ type: "text", value: zh_hans1_measure_explainer_base(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_measure_explainer_base.parts === "function" ? pt_br2_measure_explainer_base.parts(inputs) : [{ type: "text", value: pt_br2_measure_explainer_base(inputs) }]
				if (locale === "es") return typeof es_measure_explainer_base.parts === "function" ? es_measure_explainer_base.parts(inputs) : [{ type: "text", value: es_measure_explainer_base(inputs) }]
				if (locale === "fr") return typeof fr_measure_explainer_base.parts === "function" ? fr_measure_explainer_base.parts(inputs) : [{ type: "text", value: fr_measure_explainer_base(inputs) }]
				if (locale === "de") return typeof de_measure_explainer_base.parts === "function" ? de_measure_explainer_base.parts(inputs) : [{ type: "text", value: de_measure_explainer_base(inputs) }]
				if (locale === "ru") return typeof ru_measure_explainer_base.parts === "function" ? ru_measure_explainer_base.parts(inputs) : [{ type: "text", value: ru_measure_explainer_base(inputs) }]
				if (locale === "it") return typeof it_measure_explainer_base.parts === "function" ? it_measure_explainer_base.parts(inputs) : [{ type: "text", value: it_measure_explainer_base(inputs) }]
				return typeof en_measure_explainer_base.parts === "function" ? en_measure_explainer_base.parts(inputs) : [{ type: "text", value: en_measure_explainer_base(inputs) }]
			})
		}
	)
);